import { convertISODateToHumanReadableDate } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { SyncLogs } from '../sync/SyncLog';
import { useLatestSalesforceSync } from '@hooks';
import { COPY_GENERIC, COPY_SPECIFIC, ImportStatus } from '@sonar-software/sonar-ts-constants';
function renderStatus(sync, result) {
    const { finishedOn, startedOn } = sync;
    const formattedFinishedOnString = convertISODateToHumanReadableDate(finishedOn);
    const formattedStartedOnString = convertISODateToHumanReadableDate(startedOn);
    return (React.createElement("div", { className: 'status' },
        React.createElement("span", { className: 'h2' }, COPY_SPECIFIC.SUMMARY),
        React.createElement("div", { className: 'started-on' }, COPY_GENERIC.IMPORT_STARTED_ON(formattedStartedOnString)),
        React.createElement("div", { className: 'finished-on' }, COPY_GENERIC.IMPORT_FINISHED_ON(formattedFinishedOnString)),
        result));
}
export const LastSyncStatus = () => {
    const latestSync = useLatestSalesforceSync();
    if (!latestSync) {
        return null;
    }
    switch (latestSync.status) {
        case ImportStatus.Completed:
            return renderStatus(latestSync, COPY_GENERIC.IMPORT_SUCCESS);
        case ImportStatus.Failed:
            return renderStatus(latestSync, COPY_GENERIC.IMPORT_FAILURE);
        default:
            return (React.createElement("div", null,
                React.createElement("span", null, COPY_GENERIC.SYNC_IN_PROGRESS),
                React.createElement(SyncLogs, { logs: latestSync.logs })));
    }
};
